module.exports = __webpack_public_path__ + "static/reward-1-b5b434d9782067e8772deba6a89c97af.svg";